import { cn } from '~/utils/cn';

import type { ChatbotMetric } from '../../../types/chatbot-message.types';

const TREND_CLASSES = {
  up: 'text-success',
  down: 'text-error',
  neutral: 'text-foreground',
} as const;

/**
 * Single label-left / value-right row used inside StatusCard, LabeledCard, and
 * RecommendationCard. Renders an optional secondary value under the primary one
 * (e.g. "+51.5%" sub-line under "Men's Robe" in Category Standouts).
 */
export function MetricRow({
  label,
  hint,
  value,
  trend = 'neutral',
  subValue,
  subValueTrend,
}: ChatbotMetric) {
  return (
    <div className="flex items-start justify-between gap-3 text-xs">
      <div className="min-w-0 flex-1">
        <p className="text-foreground font-medium">{label}</p>
        {hint ? <p className="text-muted-foreground text-[11px] leading-tight">{hint}</p> : null}
      </div>
      <div className="max-w-[65%] min-w-0 text-right">
        <p className={cn('font-semibold break-words tabular-nums', TREND_CLASSES[trend])}>
          {value}
        </p>
        {subValue ? (
          <p
            className={cn(
              'text-[11px] leading-tight tabular-nums',
              TREND_CLASSES[subValueTrend ?? 'neutral'],
              !subValueTrend && 'text-muted-foreground',
            )}
          >
            {subValue}
          </p>
        ) : null}
      </div>
    </div>
  );
}
